import React from 'react';
import DownArrow from '../assets/images/DownArrow.svg';

export default () => {
  return <img src={DownArrow} alt="" />;
};
